import { useState, useEffect } from "react";
import { Star } from "@phosphor-icons/react";
import { motion } from "framer-motion";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const Stars = ({ rating }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map(s => (
      <Star key={s} size={14} weight={rating >= s ? "fill" : "regular"}
        className={rating >= s ? "text-[#D4A853]" : "text-[#1A1A1A]/15"} />
    ))}
  </div>
);

const ReviewsSection = ({ serviceType }) => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const params = serviceType ? `?service_type=${serviceType}` : "";
    axios.get(`${API}/api/property/reviews/public${params}`)
      .then(({ data }) => setReviews(data))
      .catch(() => {});
  }, [serviceType]);

  if (reviews.length === 0) return null;

  const avgRating = reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length;

  return (
    <section className="bg-white py-16 sm:py-20" data-testid="reviews-section">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl sm:text-2xl text-[#1A1A1A] mb-2">Avis clients</h2>
          <div className="flex items-center justify-center gap-2">
            <Stars rating={Math.round(avgRating)} />
            <span className="text-[#1A1A1A]/60 text-sm">{avgRating.toFixed(1)}/5 ({reviews.length} avis)</span>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {reviews.slice(0, 6).map((r, i) => (
            <motion.div key={r.id} initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.05 }}
              className="bg-[#EDEBE4] p-5 border border-[#1A1A1A]/5">
              <Stars rating={r.rating} />
              {r.comment && <p className="text-[#1A1A1A]/70 text-sm leading-relaxed mt-3">{r.comment}</p>}
              <p className="text-[#1A1A1A]/40 text-xs mt-3 uppercase tracking-wide">{r.client_name || "Client"}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
